export default __webpack_public_path__ + "static/media/landing_mobile.20dfc36e.gif";